import { css, Theme } from '@emotion/react'

export const subjectCardsWrapper = (theme: Theme) => css`
  display: flex;
  flex-direction: column;

  row-gap: ${theme.spacing(3)};

  margin: 0;
  padding: 0;
  list-style-type: none;
`

export const subjectCardLink = (theme: Theme) => css`
  cursor: pointer;
  display: block;

  width: 100%;
  padding: ${theme.spacing(2)};
  border-radius: 16px;
  border: none;
  outline: none;

  text-align: left;
  text-decoration: none;

  background-color: ${theme.colors.backgroundFive};

  transition: transform 300ms ease-in-out;

  :hover {
    transform: scale(1.01);
  }
`

export const withoutScale = css`
  cursor: default;

  :hover {
    transform: none;
  }
`

export const subjectTitle = (theme: Theme) => css`
  display: block;
  margin-bottom: ${theme.spacing(2.5)};

  font-size: 18px;
  font-weight: 700;
  color: ${theme.colors.typographyTwo};
`

export const progressList = (theme: Theme) => css`
  display: flex;
  flex-direction: column;

  row-gap: ${theme.spacing(2)};

  margin: ${theme.spacing(2, 0, 0)};
  padding: 0;

  list-style-type: none;
`
export const progressListItem = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;

  font-size: 16px;
  color: ${theme.colors.typographyThree};
`
